import React from 'react'
import { Box, Typography, Divider } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const TechProductList = ({ tech }) => {
    return (
        <Box>
            {tech?.prdtList === undefined ||  tech?.prdtList === null  || tech?.prdtList.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography variant="subtitle2" component="div">공급제품이 없습니다.</Typography>
                </Box>

            ) : (
                <TableContainer component={Box}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>No</TableCell>
                                <TableCell>제품명</TableCell>
                                <TableCell>모델명</TableCell>
                                <TableCell>제조업체</TableCell>
                                <TableCell>수량</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tech?.prdtList.map((product, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{product?.productNm}</TableCell>
                                    <TableCell>{product?.modelNm}</TableCell>
                                    <TableCell>{product?.partnerNm}</TableCell>
                                    <TableCell>{product?.productCnt}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    )
}

export default TechProductList